// extracted by mini-css-extract-plugin
export var bullet = "bulletedList-module--bullet--8587f";
export var bulletIcon = "bulletedList-module--bulletIcon--b228e";
export var bulletText = "bulletedList-module--bulletText--04234";
export var bulletedList = "bulletedList-module--bulletedList--4151c";
export var bullets = "bulletedList-module--bullets--35ed8";
export var buttons = "bulletedList-module--buttons--de52d";
export var dark = "bulletedList-module--dark--7aba9";
export var headline = "bulletedList-module--headline--6fa1b";
export var light = "bulletedList-module--light--cc628";